// POSLoader — the PlacementOS branded loader. The product's signature is the
// score ring, so loading IS an indeterminate score ring: a gradient (--ap-fire)
// arc sweeping around the track, a pulsing gradient "P" mark at the centre, and
// an optional label/sub. Reusable anywhere:
//
//   <POSLoader />                                    small inline spinner
//   <POSLoader size={96} label="Preparing…" sub="…"/> section loader
//   <POSLoader fullScreen label="Preparing your report" sub="…" />  page loader
//
// Uses only the .ap-* design system + one keyframe (ap-loader-rot in landing.css).
import "@/styles/landing.css";

export default function POSLoader({
  label,
  sub,
  size = 88,
  fullScreen = false,
  className = "",
}) {
  const R = 44;
  const C = 2 * Math.PI * R;

  const ring = (
    <div className={`relative mx-auto ${className}`} style={{ width: size, height: size }} role="status" aria-label={label || "Loading"}>
      {/* soft brand glow behind the ring */}
      <span className="absolute inset-0 rounded-full opacity-20 ap-pulse" style={{ background: "var(--ap-fire)", filter: "blur(10px)" }} />
      <svg viewBox="0 0 100 100" className="relative w-full h-full ap-loader-rot" aria-hidden="true">
        <defs>
          <linearGradient id="posLoaderGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#6B5CE6" />
            <stop offset="40%" stopColor="#9A59C4" />
            <stop offset="68%" stopColor="#C75C8E" />
            <stop offset="100%" stopColor="#F0734E" />
          </linearGradient>
        </defs>
        <circle cx="50" cy="50" r={R} fill="none" stroke="var(--ap-line)" strokeWidth="7" />
        <circle
          cx="50" cy="50" r={R} fill="none"
          stroke="url(#posLoaderGrad)" strokeWidth="7" strokeLinecap="round"
          strokeDasharray={C} strokeDashoffset={C * 0.7}
        />
      </svg>
      {/* pulsing brand mark */}
      <span
        className="absolute inset-0 grid place-items-center ap-display font-black ap-grad-text select-none"
        style={{ fontSize: size * 0.34 }}
      >
        P
      </span>
    </div>
  );

  const body = (
    <div className="text-center ap-rise">
      {ring}
      {label && <p className="ap-display font-extrabold text-[var(--ap-ink)] text-lg mt-5">{label}</p>}
      {sub && <p className="text-[13.5px] text-[var(--ap-muted)] mt-1.5 max-w-[300px] mx-auto leading-relaxed">{sub}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="ap-root ap-mesh min-h-screen pt-16 flex items-center justify-center" data-testid="pos-loader">
        {body}
      </div>
    );
  }
  return <div data-testid="pos-loader">{body}</div>;
}
